import { render, staticRenderFns } from "./8group.vue?vue&type=template&id=dad897f2&scoped=true&"
import script from "./8group.vue?vue&type=script&lang=js&"
export * from "./8group.vue?vue&type=script&lang=js&"
import style0 from "./8group.vue?vue&type=style&index=0&id=dad897f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad897f2",
  null
  
)

export default component.exports